import React from 'react';

// Dependency-free chart for report visuals. Supports 'bar' (flex divs) and 'line' (SVG).
// Sizing comes from the parent (set a height on the wrapper). Font sizes are passed via
// labelClass/valueClass so the TV can use vmin units and the app can use px.
const fmtNum = (n, unit) => {
  let s;
  if (Math.abs(n) >= 1000) s = n.toLocaleString(undefined, { maximumFractionDigits: 0 });
  else s = String(Math.round(n * 100) / 100);
  if (unit === '$') return `$${s}`;
  if (unit === '%') return `${s}%`;
  return unit ? `${s}${unit}` : s;
};

const MiniChart = ({ chart, color = '#3b82f6', labelClass = 'text-[10px]', valueClass = 'text-[11px]' }) => {
  const series = (chart?.series || []).filter((p) => Number.isFinite(p.value));
  if (!series.length) return null;
  const max = Math.max(...series.map((p) => p.value), 0) || 1;
  const unit = chart.unit || '';

  if (chart.type === 'line') {
    const W = 100, H = 50, pad = 4;
    const n = series.length;
    const x = (i) => (n === 1 ? W / 2 : pad + (i * (W - 2 * pad)) / (n - 1));
    const y = (v) => H - pad - (v / max) * (H - 2 * pad);
    const pts = series.map((p, i) => `${x(i)},${y(p.value)}`).join(' ');
    return (
      <div className="h-full flex flex-col min-h-0">
        {chart.title && <p className={`${labelClass} font-bold uppercase tracking-widest text-gray-500 mb-[0.6vmin] flex-shrink-0`}>{chart.title}</p>}
        <div className="flex-1 min-h-0">
          <svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" className="w-full h-full">
            <polyline fill="none" stroke={color} strokeWidth="1.4" strokeLinejoin="round" strokeLinecap="round" points={pts} />
            {series.map((p, i) => <circle key={i} cx={x(i)} cy={y(p.value)} r="1.3" fill={color} />)}
          </svg>
        </div>
        <div className="flex justify-between mt-[0.4vmin] flex-shrink-0">
          {series.map((p, i) => <span key={i} className={`${labelClass} text-gray-600 truncate`} style={{ maxWidth: `${100 / n}%` }}>{p.label}</span>)}
        </div>
      </div>
    );
  }

  // bar
  return (
    <div className="h-full flex flex-col min-h-0">
      {chart.title && <p className={`${labelClass} font-bold uppercase tracking-widest text-gray-500 mb-[0.6vmin] flex-shrink-0`}>{chart.title}</p>}
      <div className="flex-1 flex items-end gap-[1.2vmin] min-h-0">
        {series.map((p, i) => (
          <div key={i} className="flex-1 flex flex-col items-center justify-end h-full min-w-0">
            <span className={`${valueClass} font-black tabular-nums text-gray-200 mb-[0.4vmin] truncate w-full text-center`}>{fmtNum(p.value, unit)}</span>
            <div className="w-full rounded-t-md" style={{ height: `${Math.max(2, (p.value / max) * 100)}%`, backgroundColor: color, minHeight: '2px' }} />
            <span className={`${labelClass} text-gray-500 mt-[0.4vmin] truncate w-full text-center`}>{p.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MiniChart;
